<template>
  <div class="intel"
       id="intelligenttop">
    <En_topper></En_topper>
    <div class="nei_tit">
      <img src="../assets/Intelligent_tit.jpg"
           alt="">
      <span>Industrial Intelligence</span>
    </div>
    <!-- 业务介绍 -->
    <div class="nei_jieshao"
         style="height:13rem;">
      <h2>Business Introduction</h2>
      <p>In the intelligent era, ENN is actively advancing its digital transformation. Driven by the demand for "high-quality, low carbon, and intelligence" from both household users and corporate clients, ENN has developed intelligent platforms such as ENNEW.com for smart production and operations, and various industry-specific platforms including Greatgas.cn, FANNENG.com, JUAN.CN, zc.ygyg.cn, LAIKANG.com, and ENOWA. These platforms focus on integrating IoT sensors, large-scale models, and robotics to create a seamless system of "perception, cognition, and action."</p>
      <img src="../assets/Intelligent_jgt.png"
           alt=""
           style="width:9.5rem;">
    </div>

    <!-- 嗯牛网 -->
    <div class="nei_title ennew_logo"
         id="enw">
      <h3 style="font-size:.33rem; line-height:100%;">Fundamental Capability Cognitive <br />Platform</h3>
      <h4>ENNEW.com</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/enw.jpg"
           alt="">
    </div>
    <div class="nei_con">
      <p>Providing Platform Capabilities to Support the Ecosystem in Creating Intelligent Solutions.<br />
        Connecting household users and corporate clients through intelligent operations to achieve shared cognitive insights.<br />
        Enabling smart consumption for clients, precise operations for businesses, and accurate matching of supply and demand.</p>
      <a href="https://www.ennew.com/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 新智感知 -->
    <div class="nei_title xzgz_logo"
         id="xzgz">
      <h3 style="font-size:.33rem; line-height:100%;">The Digital Foundation of <br />Intelligent Manufacturing</h3>
      <h4>ENNEW SENSING</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/xzgz.jpg">
    </div>
    <div class="nei_con">
      <p>Developing IoT Perception Industrial Parks and Establishing Three Key Ecological Clusters: "Research and Development Ecosystem," "Production and Research Ecosystem," and "Market Ecosystem." By integrating these ecosystems, ENN aims to streamline the industrial chain and establish a hub for the IoT perception industry. Committed to the mission of developing and producing intelligent perception products, the company provides edge-side sensing solutions to support the digital and intelligent upgrade of the industry.</p>
      <a href="https://www.ngsense-tech.com/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 好气网 -->
    <div class="nei_title hqw_logo"
         id="hqw">
      <h3 style="font-size:.33rem; line-height:100%;">Natural Gas Capability Cognitive <br />Platform</h3>
      <h4>Greatgas.cn</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/hqw_a.jpg">
    </div>
    <div class="nei_con nei_con2">
      <p>Driven by the goal of client success, Greatgas.cn addresses challenges in the natural gas industry through intelligence. As an intelligent platform for the natural gas sector, Greatgas.cn empowers industrial enterprises, power plants, and other gas consumers, as well as city gas distributors, pipeline operators, resource suppliers, and facility providers. It resolves industry issues and enhances efficiency through advanced intelligent capabilities.</p>
      <a href="https://www.greatgas.cn/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 泛能网 -->
    <div class="nei_title fnw_logo"
         id="fnw">
      <h3 style="font-size:.33rem; line-height:100%;">Energy and Carbon Capability <br />Cognitive Platform</h3>
      <h4>FANNENG.com</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/hqw_a.jpg">
    </div>
    <div class="nei_con nei_con2">
      <p>FANNENG.com is an Energy and Carbon Capability Cognitive Platform developed by ENN Digital, a subsidiary of ENN Group. By focusing on clients' real needs of businesses and their various roles, FANNENG.com collects vast amounts of real-time data across the entire energy supply chain, from load, generation, and grid to storage. Harnessing advanced digital intelligence, it seamlessly connects supply and demand. Powered by FANNENG Intelligent Engine, composed of smart algorithms, FANNENG simulations and index evaluations, the platform offers a suite of intelligent products. These tools provide customized, flexible, and integrated energy-carbon solutions tailored to client needs. Through digital empowerment and collaboration with ecosystem partners, it helps end users to achieve safe, cost-effective, and efficient energy management, while promoting green, low-carbon, and sustainable development. FANNENG.com drives the digital transformation of the energy industry and contributes to building a modern energy system.</p>
      <a href="https://www.fanneng.com/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 聚安网 -->
    <div class="nei_title jaw_logo"
         id="jaw">
      <h3 style="font-size:.33rem; line-height:100%;">Safety Capability Cognitive Platform</h3>
      <h4>JUAN.CN</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/jaw.jpg">
    </div>
    <div class="nei_con nei_con2">
      <p>JUAN.CN is a subsidiary of ENN Group that focuses on safety capability recognition. Based on ENN's natural gas safety operation experience for more than 30 years, it integrates cutting-edge technologies such as IoT, big data, and AI to create JUAN.CN. With the "Intelligence + Platform Ecosystem" model, it provides integrated intelligent security solutions, products, and delivery services for different clients such as homes, communities, enterprises, parks, and governments, helping to achieve essential urban security.</p>
      <p>Mission: Make the city safer and everyone feel more at ease<br />
        Vision: Become a trustworthy intelligent platform for the security industry<br />
        Values: client First, Entrepreneurial Spirit, and Altruistic Coexistence</p>
      <a href="https://www.juan.cn/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 智购 -->
    <div class="nei_title zg_logo"
         id="zg">
      <h3 style="font-size:.33rem; line-height:100%;">Intelligent Supply Network Platform</h3>
      <h4>zc.ygyg.cn</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/ygzc.jpg">
    </div>
    <div class="nei_con nei_con3">
      <p>Intelligent Supply Network Platform</p>
      <p>Focused on meeting customers‘ personalized and high-quality requirements, zc.ygyg.cn reshapes supply chain system under new relations of production featuring the integration of customer satisfaction and innovation. The platform endows the demand side with intelligent capabilities of sourcing and matchmaking, design intelligence, and engineering management, and supply side with intelligent capabilities of demand cognition, quality presentation, intelligent production scheduling and delivery. And for both sides, the platform enables intelligent matchmaking, coordinated design intelligence, and coordinated delivery, etc.</p>
      <a href="https://zc.ygyg.cn/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 来康网 -->
    <div class="nei_title lkw_logo"
         id="lkw">
      <h3 style="font-size:.33rem; line-height:100%;">Health Capability Cognitive Platform</h3>
      <h4>LAIKANG.com</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/en_lkw_a.jpg">
    </div>
    <div class="nei_con nei_con2">
      <p>Health Capability Cognitive Platform</p>
      <p>Seamlessly linking demand and supply, and optimizing health resources to enhance family well-being LAIKANG.com focuses on family health needs with its mission of "reducing illness for all." It has pioneered the Sanji Entropy Suppression Health Theory, leveraging real-time health data from intelligent IoT systems. By continuously training its life and health models using scenario data and expert insights, LAIKANG.com develops advanced intelligent products and capabilities. The platform enhances industry-wide capabilities through a synchronized demand-supply intelligence approach, providing tailored health solutions to improve overall family life quality.</p>
      <a href="https://www.laikang.com/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 嗯噢哇 -->
    <div class="nei_title eow_logo"
         id="eow">
      <h3 style="font-size:.33rem; line-height:100%;">Tourism Capability Cognitive Platform</h3>
      <h4>ENOWA</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/en_eow.jpg">
    </div>
    <div class="nei_con nei_con4">
      <p>Tourism Capability Cognitive Platform</p>
      <p>Redefining travel experiences through intelligence and driving industry advancement</p>
      <p>ENOWA addresses the full spectrum of clients’ travel needs by integrating Travel Intelligence and Operational Intelligence. It enhances supply-side capabilities and redefines the value chain of the tourist industry through a dual approach of demand-driven and supply-driven intelligence. ENOWA creates a new standard for high-quality travel experiences, ensuring that every traveler enjoys a satisfying, comfortable, and enjoyable vacation. It also supports ecosystem partners in achieving operational success, providing products and services that meet precise needs. ENOWA fosters a collaborative and shared cultural tourism ecosystem, enabling travelers and partners alike to enjoy a premium travel experience and a prosperous future.</p>
      <!-- <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div> -->
    </div>

    <En_footer></En_footer>
  </div>
</template>

<script>
import En_topper from "./En_topper";
import En_footer from "./En_footer";
export default {
  components: {
    En_topper, En_footer
  },
  name: "En_intelligent",
  data () {
    return {
    };
  },
  methods: {
    loadUrl () {
      //跳锚点
      let maodian = this.$route.params.maodian;
      console.log(maodian);
      if (maodian) {
        this.$nextTick(() => {
          const targetElement = document.querySelector(maodian);
          window.scrollTo({ top: targetElement.offsetTop - 45, behavior: 'smooth' });
        })
      } else {
        window.scrollTo(0, 0);
      }
    }
  },
  mounted () {

    this.loadUrl();
  }
};
</script>

<style scoped>
.intel {
  background: #f1f2f6;
  width: 750px;
  height: auto;
  overflow: hidden;
}
.nei_tit {
  width: 750px;
  height: 450px;
  position: relative;
  margin-top: 95px;
}
.nei_tit img {
  width: 750px;
  height: 450px;
  position: absolute;
  left: 0;
  top: 0;
}
.nei_tit span {
  position: absolute;
  left: 40px;
  top: 200px;
  font-size: 48px;
  color: #fff;
  font-weight: 500;
}
h2 {
  font-size: 36px;
  color: #1d2129;
  display: block;
  padding: 60px 40px 30px 40px;
  width: 670px;
  text-align: left;
  float: left;
}
p {
  font-size: 28px;
  color: #323233;
  width: 670px;
  text-align: left;
  padding: 10px 40px;
  float: left;
}
.nei_jieshao {
  width: 750px;
  height: 440px;
  background: url(../assets/introduce_bg.jpg);
  background-size: 100% 100%;
}

.nei_title {
  width: 670px;
  height: 90px;
  float: left;
  background: #fff;
  padding: 40px;
}
.nei_title h3 {
  font-size: 30px;
  height: 40px;
  line-height: 40px;
  color: #003f84;
  text-align: left;
  width: 100%;
  display: block;
  float: left;
}
.nei_title h4 {
  font-size: 36px;
  height: 50px;
  line-height: 50px;
  color: #1d2129;
  text-align: left;
  width: 100%;
  display: block;
  float: left;
}
.ennew_logo {
  background: #fff url(../assets/ennew_logo.png) 525px 45px no-repeat;
  background-size: 178px 70px;
}
.xzgz_logo {
  background: #fff url(../assets/xzgz_logo.png) 585px 45px no-repeat;
  background-size: 117px 96px;
}
.hqw_logo {
  background: #fff url(../assets/haoqiwang_logo.png) 500px 45px no-repeat;
  background-size: 194px 70px;
}
.fnw_logo {
  background: #fff url(../assets/fanneng_logo.png) 530px 45px no-repeat;
  background-size: 177px 70px;
}
.jaw_logo {
  background: #fff url(../assets/juan_logo.png) 510px 45px no-repeat;
  background-size: 198px 70px;
}
.zg_logo {
  background: #fff url(../assets/zczg_logo.png) 490px 55px no-repeat;
  background-size: 224px 50px;
}
.lkw_logo {
  background: #fff url(../assets/laikang_logo.png) 540px 55px no-repeat;
  background-size: 163px 60px;
}
.eow_logo {
  background: #fff url(../assets/enaowa_logo.png) 520px 55px no-repeat;
  background-size: 180px 70px;
}
.nei_img,
.nei_img img {
  width: 750px;
  height: 400px;
  float: left;
}
.nei_con {
  background: #013b78 url(../assets/energy_dotbg2.png) right bottom no-repeat;
  background-size: 529px 370px;
  padding: 40px;
  float: left;
  width: 670px;
  height: auto;
  overflow: hidden;
}
.nei_con2 {
  background: #0067ca url(../assets/energy_dotbg2.png) right bottom no-repeat;
  background-size: 529px 370px;
}
.nei_con3 {
  background: #c7520a url(../assets/energy_dotbg2.png) right bottom no-repeat;
  background-size: 529px 370px;
}
.nei_con4 {
  background: #00007f url(../assets/energy_dotbg2.png) right bottom no-repeat;
  background-size: 529px 370px;
}
.nei_con p {
  color: #fff;
  font-size: 28px;
  padding-left: 0;
}

.arrow_btn {
  width: 100px;
  margin-right: 430px;
  height: 60px;
  float: left;
  background: url(../assets/arrow_white.png) left center no-repeat;
  background-size: 34px 27px;
  margin-top: 40px;
  margin-left: 80px;
}
</style>
